import { render, staticRenderFns } from "./companyMsgc.vue?vue&type=template&id=d2da167e&scoped=true"
import script from "./companyMsgc.vue?vue&type=script&lang=js"
export * from "./companyMsgc.vue?vue&type=script&lang=js"
import style0 from "@/styles/index.styl?vue&type=style&index=0&id=d2da167e&prod&lang=stylus&scoped=true&external"
import style1 from "./companyMsgc.vue?vue&type=style&index=1&id=d2da167e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2da167e",
  null
  
)

export default component.exports